import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { Button } from '../button';
import { ConfirmDialog } from '../confirm-dialog';

import { LogoutButtonProps } from './types';

export const LogoutButton = ({ className }: LogoutButtonProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['header']);

  return (
    <ConfirmDialog
      confirmBtnColor="error"
      title={t('logOutTitle')}
      message={t('logOutConfirm')}
      onConfirm={() => dispatch(logout({ byUser: true }))}
      trigger={
        <Button color="error" variant="outlined" className={className}>
          {t('logOut')}
        </Button>
      }
    />
  );
};
